import React from 'react';

const WeatherSkeleton: React.FC = () => {
  return (
    <div className="relative flex flex-col items-start w-auto lg:px-0">
      <div className="flex overflow-hidden w-full space-x-4 mb-11 p-4 bg-white shadow-md rounded-lg justify-evenly">
        <div className="flex overflow-x-hidden space-x-4 scrollbar-hide">
          {[...Array(8)].map((_, index) => (
            <div key={index} className="min-w-max flex flex-col items-center p-4 bg-gray-100 rounded-lg animate-pulse">
              <div className="h-6 w-24 bg-gray-300 rounded mb-2"></div>
              <div className="w-16 h-16 bg-gray-300 rounded-full mb-2"></div>
              <div className="h-4 w-20 bg-gray-300 rounded mb-2"></div>
              <div className="h-4 w-28 bg-gray-300 rounded mb-2"></div>
              <div className="h-4 w-24 bg-gray-300 rounded mb-2"></div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default WeatherSkeleton;
